import { defineComponent as _defineComponent } from 'vue'
import BannerContent from './bannerContent'
import { useBannerStore } from './bannerStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  setup(__props) {

const store = useBannerStore()

const dismiss = () => {
  store.dismissBanner(store.firstEligibleBanner.id)
}

return { __sfc: true,store, dismiss, BannerContent }
}

})